angular.module('licensure.internal')
    .controller('InternalNavigation', ['$scope', 'Permissions', function ($scope, Permissions) {
        $scope.getPermission = function (state, variable) {            
            Permissions.view(state).then(function (access) {
                $scope[variable] = access;
            })
        }
    }])
;